module.exports = __webpack_public_path__ + "img/donante-ethnofit.b4233efc.png";